var path = '/static/assets/khapps/lab/sample_locations/sample_location.html';
var html = "<md-card>\n    <md-content class=\"transparent\">\n        <sample-location-list></sample-location-list>\n    </md-content>\n</md-card>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;